<div class="scrolling-content-inside-modal">
  <!-- MODAL DE FILTROS MOBILE -->
  <ng-template #modalSLCIM let-modal>
    <div class="modal-header mt-1">
      <div (click)="modal.dismiss('Cross click'); cerrarModal()">
        <img lazyLoadImg class="clp-back-arrow" src="../../../assets/images/pages/icon_back_arrow.png">
      </div>
      <h4 class="modal-title center_auto fl-title-modal" id="myModalLabel1">
        Ingresa tu Origen
      </h4>
      <button type="button" class="close m-0 cerrarModalBusqueda d-none"
        (click)="modal.dismiss('Cross click'); cerrarModal()" aria-label="Close">
      </button>
    </div>
    <div>
      <form [formGroup]="formFiltroCiudadOrigen">
        <div class="input-group  pl7-pr-7 mb-1 mt-1">
          <div class="input-group-prepend">
            <span class="input-group-text" id="basic-addon-search1"> <svg xmlns="http://www.w3.org/2000/svg" width="24"
                height="24" viewBox="0 0 24 24" fill="none" stroke="#605b75" stroke-width="2" stroke-linecap="round"
                stroke-linejoin="round" class="feather feather-search ficon">
                <circle cx="11" cy="11" r="8"></circle>
                <line x1="21" y1="21" x2="16.65" y2="16.65"></line>
              </svg></span>
          </div>
          <input type="text" class="form-control" type="text" id="search-icon" name="search-icon"
            placeholder="escriba el nombre de la ciudad..." class="form-control buscador-h border-input-pre"
            formControlName="valor" />
        </div>
      </form>
    </div>
    <div class="modal-body" tabindex="0" ngbAutofocus>
      <app-filtro-lista [title]="titleList" [type]="typeList" [exclude]="excludeList" (eventEmit)="onEmit($event)"
        [valorBuscar]="valorBuscarFilterList" (eventClose)="onClose($event)"></app-filtro-lista>
    </div>
  </ng-template>
</div>

<ng-template #modalFecha let-modal>
  <div class="modal-header mt-1">
    <div (click)="modal.dismiss('Cross click'); cerrarModal()">
      <img lazyLoadImg class="clp-back-arrow" src="../../../assets/images/pages/icon_back_arrow.png">
    </div>
    @if (typeCalendar == 0 || typeCalendar == 1) {
      <h4 class="modal-title center_auto fl-title-modal">
        ¿Cuándo viajas?
      </h4>
    }
    <button type="button" class="close m-0 cerrarModalBusqueda d-none" (click)="modal.dismiss('Cross click')"
      aria-label="Close">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body fl_filter" tabindex="0" ngbAutofocus>
    @if (typeCalendar == 0) {
    <div style="    font-weight: bold;
    font-size: 16px;
    line-height: 19px;
    display: flex;
    -webkit-box-align: center;
    align-items: center;
    color: var(--primary);">Fecha de ida</div> <!-- celular -->
    }
    @if (typeCalendar == 1) {
    <div style="    font-weight: bold;
        font-size: 16px;
        line-height: 19px;
        display: flex;
        -webkit-box-align: center;
        align-items: center;
        color: var(--primary);" >Fecha de Regreso</div>
    }
    <hr>
    <form [formGroup]="form">
      @if (typeCalendar == 0) {
        <ngb-datepicker  (dateSelect)="onDateSelect($event)" [minDate]="minDate"
          [maxDate]="maxDateStart" [value]="dateStartMobile" [displayMonths]="1" [outsideDays]="outsideDays"
          [showWeekNumbers]="showWeekNumbers" [markDisabled]="isDisabled" [navigation]="navigationModal"
          [footerTemplate]="footerTemplateida" formControlName="dateStart">
        </ngb-datepicker>
      }
      @if (typeCalendar == 1) {
        <ngb-datepicker (dateSelect)="onDateSelectEnd($event)" [minDate]="minDateEnd"
          [value]="dateEndMobile" [displayMonths]="1" [outsideDays]="outsideDays" [showWeekNumbers]="showWeekNumbers"
          [dayTemplate]="customDayReg" [markDisabled]="isDisabled" [navigation]="navigationModal"
          [footerTemplate]="footerTemplateVuelta" formControlName="dateEnd">
        </ngb-datepicker>
      }
    </form>
    <ng-template #footerTemplateida>
      <hr class="my-0" />
      <button class="btn btn-outline-primary btn-md mt-1" (click)="asignarFechaHoy(0); cerrarModalBusquedaCiudades()"
        rippleEffect>
        Hoy
      </button>
    </ng-template>
    <ng-template #footerTemplateVuelta>
      <hr class="my-0" />
      <button class="btn btn-outline-danger btn-md float-right mt-1"
        (click)="limpiarFecha(); cerrarModalBusquedaCiudades()" rippleEffect>
        Limpiar
      </button>
    </ng-template>
  </div>
</ng-template>
<!-- NO SE ESTÁ USANDO -->
<ng-template #contentList>
  <div class="modal fade clienteFrecuenteId show p-0" tabindex="-1" role="dialog" style="display: block"
    aria-labelledby="myLargeModalLabel" aria-hidden="true" data-backdrop="static" data-keyboard="false">
    <div class="modal-dialog" style="max-width:280px;">
      <div class="modal-content min-height-modal">
        <div class="modal-header bg-transparent pos_absolute_close">
          <svg class="btn-close" data-dismiss="modal" aria-label="Close" (click)="close()"
            xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
            stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
            class="feather feather-x">
            <line x1="18" y1="6" x2="6" y2="18"></line>
            <line x1="6" y1="6" x2="18" y2="18"></line>
          </svg>
        </div>
        <div class="modal-body px-sm-0 mx-0 pb-0"></div>
      </div>
    </div>
  </div>
</ng-template>
<!-- template fecha celular -->
<ng-template #contentHour let-modal>
  <div class="theme-hero-text-title title-filter-list bg_filter _mb-0 head-calendar">
    <div (click)="close()" class="button-modal-close close-calendar">
      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
        stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
        class="feather feather-x font-medium-3">
        <line x1="18" y1="6" x2="6" y2="18"></line>
        <line x1="6" y1="6" x2="18" y2="18"></line>
      </svg>
    </div>
    @if (typeCalendar == 0) {
      <h4 class="text-center mb-1 mt-1 text-calendar">
        Fecha de ida
      </h4>
    }
    @if (typeCalendar == 1) {
      <h4 class="text-center mb-1 mt-1 text-calendar">
        Fecha de Regreso
      </h4>
    }
  </div>
  <div class="modal-center modal-center-mobile">
    @if (typeCalendar == 0) {
      <ngb-datepicker  (dateSelect)="onDateSelect($event)" [minDate]="minDate"
        [maxDate]="maxDateStart" [value]="dateStartMobile" [displayMonths]="1" [outsideDays]="outsideDays"
        [showWeekNumbers]="showWeekNumbers" [markDisabled]="isDisabled" [navigation]="navigationModal">
      </ngb-datepicker>
    }
    @if (typeCalendar == 1) {
      <ngb-datepicker  (dateSelect)="onDateSelectEnd($event)" [minDate]="minDateEnd"
        [value]="dateEndMobile" [displayMonths]="1" [outsideDays]="outsideDays" [showWeekNumbers]="showWeekNumbers"
        [dayTemplate]="customDayReg" [markDisabled]="isDisabled" [navigation]="navigationModal">
      </ngb-datepicker>
    }
    <div class="content-right">
      @if (typeCalendar == 1) {
        <button  class="btn btn-flat-primary waves-effect" (click)="resetEnd(); close()">
          Limpiar
        </button>
      }
      <input autofocus type="text" style="width: 0; position: absolute; top: -1em; height: 0" />
    </div>
  </div>
</ng-template>
@if (muestraBarra) {
  <!--DESKTOP-->
  <form  [ngClass]="lateral == true ? 'd-none' : 'd-none d-lg-block d-xl-block'" [formGroup]="form"
    class="form form-vertical">
    <div class="row">
      <div class="col-3 p-0 text_aling_left">
        <label class="text-label-buscador">Origen</label>
        <div class="input-group mb-0" style="margin-right: 40px !important;">
          <div class="input-group-prepend d-none">
            <span class="input-group-text noborder"
              style="border-top-left-radius: 5px !important; border-bottom-left-radius: 5px !important;">
              <svg class="feather feather-crosshair font-medium-3" fill="none" height="24" stroke="currentColor"
                stroke-linecap="round" stroke-linejoin="round" stroke-width="2" viewBox="0 0 24 24" width="24"
                xmlns="http://www.w3.org/2000/svg">
                <circle cx="12" cy="12" r="10"></circle>
                <line x1="22" x2="18" y1="12" y2="12"></line>
                <line x1="6" x2="2" y1="12" y2="12"></line>
                <line x1="12" x2="12" y1="6" y2="2"></line>
                <line x1="12" x2="12" y1="22" y2="18"></line>
              </svg>
            </span>
          </div>
          <ng-select
            class="fs-busq ng-select form-control ng-select-single ng-select-searchable ng-select-clearable ng-select-bottom p-0 noborder"
            style="margin-right: 40px !important;" [items]="cities" bindLabel="city" [loading]="loadingCitiesOrigin" loadingText="Cargando las ciudades..."
            dropdownPosition="{{ this.dropdownPosition }}" placeholder="¿Desde donde viajas?" notFoundText="No hay origenes" clearAllText="Descartar" 
            formControlName="origin" (click)="abrirOrigenDelViajeWeb(agreeSelect)" [isOpen]="abrirOrigenViajeWeb">
          </ng-select>
          @if(this._InfoEmpresa)
          {
           <div  [ngStyle]="{'background-color': _InfoEmpresa[0].color}" class="change_city" (click)="intercambiar()">
            <span>
              <img lazyLoadImg style="rotate:0deg;" src="../../../assets/images/varias/change.png" width="25" height="25" alt="intercambiar" title="intercambiar">
            </span>
          </div> 
        }@else {
          <div  [ngStyle]="{'background-color': '#e91e63'}" class="change_city" (click)="intercambiar()">
            <span>
              <img lazyLoadImg style="rotate:0deg;" src="../../../assets/images/varias/change.png" width="25" height="25" alt="intercambiar" title="intercambiar">
            </span>
          </div> 
        }
        </div>
      </div>
      <div class="col-3 p-0 text_aling_left">
        <label class="text-label-buscador">Destino</label>
        <div class="input-group mb-0">
          <div class="input-group-prepend  d-none">
            <span class="input-group-text noborder border-left">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                class="feather feather-map-pin font-medium-3">
                <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"></path>
                <circle cx="12" cy="10" r="3"></circle>
              </svg>
            </span>
          </div>
  
          <ng-select #agreeSelect
            class="fs-busq setDestinoViajeWeb ng-select form-control ng-select-single ng-select-searchable ng-select-clearable ng-select-bottom p-0 noborder ng-touched ng-select-opened ng-pristine ng-valid ng-select-focused"
            [items]="cities" bindLabel="city" notFoundText="No hay destinos" clearAllText="Descartar" placeholder="¿Donde quieres ir?"
            dropdownPosition="{{ this.dropdownPosition }}" formControlName="destination" [loading]="loadingCitiesDestination" loadingText="Cargando las ciudades..."
            (click)="abrirDestinoDelViajeWeb()" [isOpen]="abrirDestinoViajeWeb">
          </ng-select>
        </div>
      </div>
  
      <div class="col-2 p-0 text_aling_left">
        <label class="text-label-buscador"><img lazyLoadImg src="../../../assets/images/pages/cal.png" alt="Fecha de ida" title="Fecha de ida" style="margin-right:15px ;" width="16" height="17">Fecha de ida</label>
        <div class="input-group mb-0" style="border-left: thin solid #00000024;padding-left: 30px;">
          <input class="abrirFechaIdaWeb form-control noborder fs-busq" style="padding-top: 24px;"
            placeholder="Fecha ida" [(ngModel)]="fechaIdaCalendario" [maxDate]="minDate"
            [minDate]="minDatePicker" formControlName="dateStart" (click)="cambiosFechaVuelta(); fechaIda.toggle()"
            [footerTemplate]="footerTemplateida" ngbDatepicker #fechaIda="ngbDatepicker" />
          <ng-template #footerTemplateida>
            <hr class="my-0" />
            <button class="btn btn-primary btn-sm m-1 hoy-btn" (click)="asignarFechaHoy(0); fechaIda.close()"
              rippleEffect>
              Hoy
            </button>
          </ng-template>
          <ng-template #customDay let-date let-currentMonth="currentMonth" let-selected="selected" let-disabled="disabled"
            let-focused="focused">
            <span class="custom-day" [class.weekend]="isWeekend(date)" [class.focused]="focused" [class.today]="selected"
              [class.hidden]="date.month !== currentMonth" [class.text-muted]="disabled">
              {{ date.day }}
            </span>
          </ng-template>
        </div>
      </div>
  
      <div class="col-2 p-0 text_aling_left pointer">
        <label class="text-label-buscador"><img lazyLoadImg src="../../../assets/images/pages/cal.png" alt="Regreso (Opc)" title="Regreso (Opc)" style="margin-right:15px ;" width="16" height="17"> Regreso (Opc) </label>
        <div class="input-group mb-0" style="border-left: thin solid #00000024;padding-left: 30px;">
          <input autocomplete="off" class="form-control noborder fs-busq" style="padding-top: 24px;"
            placeholder="Fecha regreso" name="Basic Date Picker"
            [(ngModel)]="fechaVueltaCalendario" [minDate]="minDateEnd" [footerTemplate]="footerTemplateVuelta"
            [dayTemplate]="customDayVuelta" ngbDatepicker (click)="cambiosFechaIda(); fechaVuelta.toggle()"
            formControlName="dateEnd" #fechaVuelta="ngbDatepicker" />
  
          <ng-template #footerTemplateVuelta>
            <hr class="my-0" />
            <button class="btn btn-primary btn-sm m-1 float-left" (click)="asignarFechaHoy(1); fechaVuelta.close()"
              rippleEffect>
              Hoy
            </button>
            <button class="btn btn-danger btn-sm m-1 float-right" (click)="limpiarFechaVuelta(); fechaVuelta.close()"
              rippleEffect>
              Limpiar
            </button>
          </ng-template>
  
          <ng-template #customDayVuelta let-date let-currentMonth="currentMonth" let-selected="selected"
            let-disabled="disabled" let-focused="focused">
            <span class="custom-day" [class.weekend]="isWeekend(date)" [class.focused]="focused" [class.today]="selected"
              [class.hidden]="date.month !== currentMonth" [class.text-muted]="disabled">
              {{ date.day }}
            </span>
          </ng-template>
        </div>
      </div>
  
      <div class="col-2 p-0">
        @if(this._InfoEmpresa)
        {
          <button [ngStyle]="{'background-color':this._InfoEmpresa[0].color || '#e91e63'}" (click)="viewTravels()" type="submit" [class]="this.ws.newComplemt != 'movired' ? 
          'btn btn-primary_search me-1 waves-effect waves-float waves-light btn_ajuste_buscar' 
          : 'btn btn-primary_search me-1 waves-effect waves-float waves-light btn_ajuste_buscar borde_blanco_btn'">
    Buscar   
  </button>
        }@else
        {
          <button [ngStyle]="{'background-color': '#e91e63'}" (click)="viewTravels()" type="submit" [class]="this.ws.newComplemt != 'movired' ? 
          'btn btn-primary_search me-1 waves-effect waves-float waves-light btn_ajuste_buscar' 
          : 'btn btn-primary_search me-1 waves-effect waves-float waves-light btn_ajuste_buscar borde_blanco_btn'">
    Buscar
  </button>
        }

      </div>
    </div>
  </form>
}
@if(muestraBarra) {
  <!--MOBILE-->
  <form  [formGroup]="form" [ngClass]="{ 'd-lg-none d-xl-none': lateral === false }"
    class="form form-vertical">
    <!-- <ng-template #footerTemplateStart>
      <hr class="my-0" />
      <div class="center">
        @if (lang == 'en') {
          <button  class="btn btn-flat-primary waves-effect" (click)="resetStart(); from_date1.close()">
            Clear
          </button>
        }
        @if (lang == 'en') {
          <button  class="btn btn-flat-secondary waves-effect float-rigt" (click)="from_date1.close()">
            Close
          </button>
        }
        @if (lang == 'es') {
          <button  class="btn btn-flat-primary waves-effect" (click)="resetStart(); from_date1.close()">
            Limpiar
          </button>
        }
        @if (lang == 'es') {
          <button class="btn btn-flat-secondary waves-effect float-rigt" (click)="from_date1.close()">
            Cerrar
          </button>
        }
      </div>
    </ng-template> -->
    <!-- <ng-template #footerTemplateEnd>
      <hr class="my-0" />
      <div class="center" style="border: blue solid 1px;">
        @if (lang == 'en') {
          <button  class="btn btn-flat-primary waves-effect" (click)="resetEnd(); to_date1.close()">
            Clear
          </button>
        }
        @if (lang == 'en') {
          <button  class="btn btn-flat-secondary waves-effect float-rigt" (click)="to_date1.close()">
            Close
          </button>
        }
        @if (lang == 'es') {
          <button  class="btn btn-flat-primary waves-effect" (click)="resetEnd(); to_date1.close()">
            Limpiar
          </button>
        }
        @if (lang == 'es') {
          <button  class="btn btn-flat-secondary waves-effect float-rigt" (click)="to_date1.close()">
            Cerrar
          </button>
        }
      </div>
    </ng-template> -->
    <div class="row mb-1 margin-2pxobile">
      <div class="col-12 p-0 text_aling_left pos_relative mb-1 margin-2pxobile">
        <label class=" label-mobile"> Origen </label>
        <div class="input-group mb-0">
          <input class="form-control hg60 btr5 ptop20 noborder bdright-roud pl-mob-0  font-mob"
            style="border-top-right-radius: 10px !important;border-top-left-radius: 10px !important" (click)="openOrigin(contentList, modalSLCIM)" readonly
            bindLabel="city" formControlName="origin" placeholder="¿Desde donde viajas?" />
          <div (click)="intercambiar()">
            @if(this._InfoEmpresa)
            {
              <div  [ngStyle]="{'background-color': this._InfoEmpresa[0].color}" class="change_city_mob"><img lazyLoadImg style="rotate:90deg;" src="../../../assets/images/varias/change.png" width="30" height="30" alt="intercambiar" title="intercambiar"></div>
            }@else
            {
              <div  class="change_city_mob"><img lazyLoadImg style="rotate:90deg;" src="../../../assets/images/varias/change.png" width="30" height="30" alt="intercambiar" title="intercambiar"></div>
            }
          </div>
        </div>
      </div>
      <div class="col-12 p-0 text_aling_left pos_relative">
        <label class="label-mobile"> Destino </label>
        <div class="input-group ">
          <input class="form-control hg60 btr0 ptop20 noborder bdright-roud pl-mob-0  font-mob"
            style="border-top-right-radius: 0px !important" readonly (click)="openDestination(contentList, modalSLCIM)"
            bindLabel="city" formControlName="destination" placeholder="¿Donde quieres ir?" />
        </div>
      </div>
    </div>
  
    <!-- versión móvil -->
    <div class="row mb-1 ">
      <div class="col-6 p-0 text_aling_left pos_relative">
        <label class="label-mobile">
          <img lazyLoadImg src="../../../assets/images/pages/cal.png" style="margin-right:15px ;" alt="Fecha de ida" title="Fecha de ida" width="16" height="17"> Fecha de ida
        </label>
        <div class="input-group">
          <input class="form-control hg60  noborder bg-white pl-mob-0 font-mob" style="padding-right: 0px" readonly
            placeholder="dd-mm-yyyy" formControlName="dateStart" name="from_date1" (click)="open(0, modalFecha)"
            [(ngModel)]="fechaIdaCalendario" ngbDatepicker [maxDate]="minDate" #fechaIda="ngbDatepicker" />
        </div>
      </div>
  
      <div class="col-6 p-0 text_aling_left pos_relative" style="border-left: 5px solid transparent;">
        <label class="text-white label-mobile">
          <img lazyLoadImg src="../../../assets/images/pages/cal.png" style="margin-right:15px ;" alt="Regreso (Opc)" title="Regreso (Opc)" width="16" height="17"> Regreso (Opc)
        </label>
        <div class="input-group ">
          <input class="form-control hg60  noborder bg-white pl-mob-0 font-mob" readonly (click)="open(1, modalFecha)"
            name="to_date1" formControlName="dateEnd" [(ngModel)]="fechaVueltaCalendario" [minDate]="minDateEnd"
            ngbDatepicker #fechaVuelta="ngbDatepicker" placeholder="Fecha regreso" />
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-12 mb-0 p-0">
        @if(this._InfoEmpresa)
        {
        <button  [ngStyle]="{'background-color': this._InfoEmpresa[0].color || '#e91e63'}" (click)="viewTravels()" type="submit"
          class="btn  me-1 waves-effect waves-float waves-light mt-0  btn-lg"
          style="height: 60px; width: 100%; border: none !important;color: white;">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
            stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
            class="feather feather-search font-medium-3">
            <circle cx="11" cy="11" r="8"></circle>
            <line x1="21" y1="21" x2="16.65" y2="16.65"></line>
          </svg>
          Buscar
        </button>
      }@else {
        <button (click)="viewTravels()" type="submit"
        class="btn  me-1 waves-effect waves-float waves-light mt-0 btn-primary btn-lg"
        style="height: 60px; width: 100%; background-color: var(--secondary) !important; border: none !important;">
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
          stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
          class="feather feather-search font-medium-3">
          <circle cx="11" cy="11" r="8"></circle>
          <line x1="21" y1="21" x2="16.65" y2="16.65"></line>
        </svg>
        Buscar
      </button>    
      }
      </div>
    </div>
  </form>
}
